export const TIME_REGEX_HOURS = '^([0-1]?[0-9]|[2][0-3]):([0-5][0-9])(:[0-5][0-9])$';
export const TIME_REGEX_DAYS = '^[0-9]* ([0-1]?[0-9]|[2][0-3]):([0-5][0-9])(:[0-5][0-9])$';
